import { financialFormat } from "./financialFormat";

export const financialFormatWithHostDiscount = (precio, descuento) => {
  const precioSeguro = precio ?? 0;
  const descuentoFinal = (descuento ?? 0) / 10000;

  const importeConDescuento =
    precioSeguro - precioSeguro * descuentoFinal;

  return financialFormat(Math.round(importeConDescuento));
};